import React from "react";
import { Grid } from "@mui/material";
import { StriimModal, StriimTypography } from "@striim/striim-ui";

interface FullScreenInputModalProps {
    InputComponent: React.ReactNode;
    RightSection?: React.ReactNode;
    onCancel: () => void;
    onConfirm: () => void;
}

const FullScreenInputModal: React.FC<FullScreenInputModalProps> = ({
    InputComponent,
    RightSection,
    onCancel,
    onConfirm
}) => {
    return (
        <StriimModal
            autoHeight
            size="large"
            onCancel={onCancel}
            onConfirm={onConfirm}
            isVisible={true}
            titleContent={<></>}
            footerBorder={true}
            confirmContent={"Done"}
            dialogProps={{
                sx: {
                    ".MuiDialog-paper": {
                        width: "1036px"
                    }
                }
            }}
        >
            <Grid container flexDirection={"column"}>
                <Grid item display="flex" gap={2}>
                    <Grid container flexDirection={"column"} flex={RightSection ? 0.72 : 1}>
                        {InputComponent}
                    </Grid>
                    {RightSection ? (
                        <Grid item display="flex" flex={0.28}>
                            {RightSection}
                        </Grid>
                    ) : null}
                </Grid>
            </Grid>
        </StriimModal>
    );
};

export default FullScreenInputModal;
